import { Box, Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import React, { useRef } from "react";
import { BsUpload } from "react-icons/bs";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";

interface InputExcelProps {
  onReadExcelFile: (file: File | null) => any;
  variant?: "primary" | "outline";
  label?: string;
  includeIcon?: boolean;
  icon?: React.ReactNode;
}

function InputExcel({
  onReadExcelFile,
  variant = "primary",
  label = "Arquivo Excel",
  includeIcon = true,
  icon = (
    <BsUpload
      size={20}
      color={variant === "primary" ? colors.white : colors.blue300}
    />
  ),
}: InputExcelProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onClick = () => {
    inputRef.current && inputRef.current.click();
  };

  const Button = variant === "primary" ? PrimaryButton : OutlineButton;

  return (
    <>
      <Box as="span" display="none">
        <input
          ref={inputRef}
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={(ev) =>
            ev.target.files?.length && onReadExcelFile(ev.target.files[0])
          }
        />
      </Box>
      <Button onClick={onClick} justifyContent="center">
        <Flex alignItems="center">
          {includeIcon ? icon : null}
          <Text
            fontSize={13}
            color={variant === "primary" ? colors.white : colors.blue300}
            ml={includeIcon ? 2 : 0}
            fontWeight="400"
          >
            {label}
          </Text>
        </Flex>
      </Button>
    </>
  );
}

export default InputExcel;
